import React, { useState, useEffect, Fragment } from "react";
import { verifyEvent } from "../Helpers/Helper";

export default function SWEventStructure({ widget }) {
  const [event, setEvent] = useState(widget ? verifyEvent(widget):false);

  useEffect(() => {
    if(widget)
    setEvent(verifyEvent(widget));
  }, [widget]);

  return (
    <div
      style={{
        height: "100vh",
        width: "400px",
        border: "1px solid var(--pale-gray)",
        overflow: "scroll"
      }}
    >
      {!widget && (
        <div className="fit-container fit-height fx-centered fx-col">
          <h4>No widget</h4>
          <p className="gray-c">The widget data will be analysed here</p>
        </div>
      )}
      {!event && widget && (
        <div className="fit-container fit-height fx-centered fx-col">
          <h4>Invalid widget</h4>
        </div>
      )}
      {event && widget && <EventStructure event={event} />}
    </div>
  );
}

const EventStructure = ({ event }) => {
  return (
    <div className="box-pad-h-m box-pad-v-m fx-centered fx-col fx-start-h fx-start-v">
      <div>
        <p>Title</p>
        <h4>{event.content || "N/A"}</h4>
      </div>
      <hr />
      <div>
        <p>Identifier</p>
        <p className="gray-c">{event.identifier || "N/A"}</p>
      </div>
      <hr />
      <div>
        <p>Pubkey</p>
        <p className="gray-c">{event.pubkey || "N/A"}</p>
      </div>
      <hr />
      <div>
        <p>Event kind</p>
        <p className="gray-c">{event.kind || "N/A"}</p>
      </div>
      <div>
        <p>Smart widget type</p>
        <p className="gray-c">{event.type || "N/A"}</p>
      </div>
      <div>
        <p>Smart widget icon</p>
        <p className="gray-c p-three-lines">{event.icon || "N/A"}</p>
      </div>
      <hr />
      <div>
        <p>Components</p>
        <div className="box-pad-h box-pad-v-s fx-centered fx-col fx-start-h fx-start-v">
          <div>
            <p>image</p>
            <p className="gray-c p-three-lines">{event.image || "N/A"}</p>
          </div>
          <hr />
          {event.input && (
            <>
              <div>
                <p>input</p>
                <p className="gray-c">{event.input || "N/A"}</p>
              </div>
              <hr />
            </>
          )}
          {event.buttons.map((btn, index) => {
            return (
              <Fragment key={index}>
                <div>
                  <p>Button {index + 1}</p>
                  <div className="box-pad-h box-pad-v-s fx-centered fx-col fx-start-h fx-start-v">
                    <div className="fit-container fx-centered fx-start-h fx-start-v">
                      <p className="c1-c" style={{minWidth: "50px"}}>label</p>
                      <p className="gray-c">{btn.label || "N/A"}</p>
                    </div>
                    <hr />
                    <div className="fit-container fx-centered fx-start-h fx-start-v">
                      <p className="c1-c" style={{minWidth: "50px"}}>type</p>
                      <p className="gray-c">{btn.type || "N/A"}</p>
                    </div>
                    <hr />
                    <div className="fit-container fx-centered fx-start-h fx-start-v">
                      <p className="c1-c" style={{minWidth: "50px"}}>url</p>
                      <p className="gray-c p-three-lines">{btn.url || "N/A"}</p>
                    </div>
                  </div>
                </div>
                <hr />
              </Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
};
